import { createApp } from "vue";
import App from "./App.vue";
import "./assets/css/main.css";
import router from "./router";
import "bootstrap";
import { BootstrapVueNext } from "bootstrap-vue-next";
import "./assets/vendors/mdi/css/materialdesignicons.min.css";
import "./assets/vendors/css/vendor.bundle.base.css";
import "vue3-toastify/dist/index.css";
import Vue3Toastify from "vue3-toastify";
import axios from "axios";
import { createPinia } from "pinia";
import primeVue from "primevue/config";
import "primevue/resources/primevue.min.css";
import "primevue/resources/themes/aura-light-green/theme.css";
import ConfirmationService from "primevue/confirmationservice";
import { LoadingPlugin } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import DialogService from "primevue/dialogservice";
import Tooltip from "primevue/tooltip";
import CryptoJS from "crypto-js";

const app = createApp(App);

axios.defaults.withCredentials = true;
// axios.defaults.baseURL = "http://localhost:5000/"; //local api URL
// axios.defaults.baseURL = "http://versionvaultUAT.maxcessiot.com:5000/"; //UAT Env URL
axios.defaults.baseURL = "https://versionvault.maxcessiot.com:5000/"; // Prod API URL
export const email_regex = /^[A-Za-z0-9._%+-]+(@maxcessintl|@maxcess)\.(com|eu)$/;

app.config.globalProperties.$modalConfig = {
  id: "modal-center",
  title: "Delete Confirmation",
  message: "Are you sure you want to delete the product release?",
};

app.config.globalProperties.$loading = false;

app
  .use(LoadingPlugin, {
    // props
    loader: "spinner",
    color: "#163A64",
  })
  .use(CryptoJS)
  .directive("tooltip", Tooltip)
  .use(DialogService)
  .use(createPinia())
  .use(ConfirmationService)
  .use(primeVue)
  .use(Vue3Toastify)
  .use(BootstrapVueNext)
  .use(router)
  .mount("#app");
